import { ArticleAttribute, EApplication, EAxlePosition } from "@tm/models"
import { useMemo } from "react"
import { styled } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { Tooltip } from "../../../../../muiStyled/DataDisplay/tooltip"
import TruckTyrePositionTooltip from "./TruckTyrePositionTooltip"
import { Image } from "../../../../image"
import { getTruckTyreIconPath } from "../helpers/getTruckTyreIconPath"
import { getTruckTyreApplicationTextId } from "../helpers/getTruckTyreApplicationTextId"

type Props = {
    application: ArticleAttribute
    axlePosition: ArticleAttribute
    isCompact?: boolean
}

const StyledTooltip = styled(Tooltip)(({ theme }) => ({
    "& .MuiTooltip-tooltip, & .MuiTooltip-arrow::before": {
        borderColor: theme.palette.primary.main,
    },
}))

const CompactStyledImage = styled(Image)({
    height: "16px",
    width: "auto",
    cursor: "pointer",
})

const ExtendedStyledImage = styled(Image)({
    height: "24px",
    width: "auto",
    cursor: "pointer",
})

export default function TruckTyrePositionIcon({ application, axlePosition, isCompact = false }: Props) {
    const { translateText } = useLocalization()

    const iconPath = useMemo(() => {
        return getTruckTyreIconPath(application.key as EApplication, axlePosition.key as EAxlePosition)
    }, [application, axlePosition])

    const applicationText = useMemo(() => {
        const textId = getTruckTyreApplicationTextId(application.key as EApplication)
        return textId ? translateText(textId) : null
    }, [application, translateText])

    if (!iconPath || !applicationText) {
        return null
    }

    return (
        <StyledTooltip variant="light" title={<TruckTyrePositionTooltip iconPath={iconPath} application={applicationText} />}>
            {isCompact ? <CompactStyledImage src="/styles/base/images/truck-body.png" /> : <ExtendedStyledImage src={iconPath} />}
        </StyledTooltip>
    )
}
